import { ClearRounded } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Input } from "../../../../controls";
import { CartContext } from "../POS";
import { action, API, controller } from "../../../../api/api";
import {
  BGNestedObjToFromData,
  lsGet,
  RmvArryEmptyProp,
} from "../../../../hooks/Method";
import { AppContext } from "../../../../App";
import { Model } from "../../../../hooks";
import { Form } from "../../../../layout";
import { useNavigate } from "react-router-dom";

const ParkSaleForm = (props) => {
  const { setShowForm, setSnackbar } = props;
  const navigate = useNavigate();
  const activeReg = lsGet("activeReg");
  const { SellMdl } = Model();
  const { authUser } = useContext(AppContext);
  const { cartData, setCartData } = useContext(CartContext);
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({});

  useEffect(() => {
    if (cartData && cartData.sellItems.length > 0) {
      setValues({
        parkItems: cartData.sellItems.map((j) => ({
          ...j,
          prod: "",
          varProd: "",
        })),
        note: cartData.note,
        discount: cartData.discount,
        customerId: cartData.customerId,
        disType: cartData.disType,
        disAmt: cartData.disAmt,
        taxId: cartData.taxId,

        sellRegId: activeReg.id,
        outletId: activeReg.outletId,
        orgId: authUser.orgId,
        parkDate: new Date().toLocaleString(),
      });
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData]);

  const handleClose = () => {
    setShowForm(false);
  };

  const handleNoteChg = (e) => {
    setCartData((j) => ({ ...j, note: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (activeReg && authUser) {
      const onComplete = (res) => {
        setLoading(false);
        if (res && res.status === 201) {
          setCartData(SellMdl);
          navigate("/sell");
          setSnackbar({
            show: true,
            type: "success",
            msg: "Park succeed",
          });
          setShowForm(false);
        } else if (res) {
          setSnackbar({
            show: true,
            type: "error",
            msg: res.msg,
          });
          setShowForm(false);
        }
      };

      setLoading(true);
      API(controller.ParkSale + action.Post).post(
        BGNestedObjToFromData(
          RmvArryEmptyProp({
            ...values,
            id: "",
            parkItems: values.parkItems.map((item) => ({ ...item, id: "" })),
          })
        ),
        onComplete
      );
    }
  };

  return (
    <Form onSubmit={handleSubmit} noValidate>
      <div className="grid gap-[15px]">
        <div className="flex justify-between items-center border-b p-[8px] pb-[3px]">
          <span className="text-[20px] text-gray-500 font-medium ml-[5px]">
            Add a note to the sale
          </span>

          <div>
            <IconButton onClick={handleClose}>
              <ClearRounded />
            </IconButton>
          </div>
        </div>
        <div className="grid gap-[15px] p-[15px]">
          <span className="text-gray-500 text-[14px]">
            You are about to park this sale. Add a note so it can be identified
            by the next person who continues this sale.
          </span>
          <div>
            <Input
              label="Note"
              value={cartData.note}
              variant="outlined"
              multiline
              rows={3}
              onChange={handleNoteChg}
            />
            <span className="text-[12px] text-gray-400 tracking-wider ml-[10px]">
              Max characters: 500
            </span>
          </div>
          <div className="text-right">
            <Button
              loading={loading}
              type="submit"
              className="min-w-[150px]"
              size="large"
            >
              Park Sale
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default ParkSaleForm;
